import { Component, OnDestroy, OnInit } from '@angular/core';

import { CognitoUser } from '../../shared/interfaces/cognito-user';

import { CognitoService } from '../../auth/cognito.service';
import { UsersService } from '../../pages/users/users.service';
import { APIService, GetUserQuery, User } from '../../app-sync.service';
import { Router } from '@angular/router';
import { FeedbacksService } from 'src/app/shared/feedbacks/feedbacks.service';

@Component({
  selector: 'app-business-selector',
  templateUrl: './business-selector.component.html',
  styleUrls: ['./business-selector.component.css'],
})
export class BusinessSelectorComponent implements OnInit, OnDestroy {
  activeCognitoUser: CognitoUser | null = null;
  activeUser: User;

  constructor(
    private cognitoService: CognitoService,
    private usersService: UsersService,
    private router: Router,
    private api: APIService,
    private feedbacksService: FeedbacksService
  ) {
    this.activeUser = this.usersService.getActiveUser();
    this.usersService.inBusinessSelector.next(true);
  }

  async ngOnInit() {
    this.cognitoService.getUser().then((user: any) => {
      this.activeCognitoUser = user.attributes;
    });

    await this.api
      .GetUser(this.activeUser!.email)
      .then((user: GetUserQuery) => {
        // Acá se inicia el usuario del UsersService
        this.usersService.setActiveUser(user);
        const businessesList: string[] = user.hasAccessTo
          ? user.hasAccessTo.split(',')
          : [];
        if (businessesList.length === 1) {
          this.router
            .navigate(['/home/' + user.business.toLowerCase()])
            .then(() => {
              this.usersService.business.next(user.business.toLowerCase());
            });
        }
      })
      .catch((response: any) => {
        if (Symbol.iterator in Object(response.errors)) {
          this.feedbacksService.showErrorFeedbacks(
            response,
            `Error al cargar datos del usuario ${this.activeUser!.email}`
          );
        }
      });
  }

  showButton(business: string): boolean {
    const businessList: string[] = this.activeUser.hasAccessTo!.split(',');
    return businessList.includes(business.toUpperCase());
  }

  onNoCoreSelected() {
    this.router.navigate(['/home/nocore']).then(() => {
      this.usersService.business.next('nocore');
    });
  }

  onLubricantsSelected() {
    this.router.navigate(['/home/lubricants']).then(() => {
      this.usersService.business.next('lubricants');
    });
  }

  onForeignSelected() {
    this.router.navigate(['/home/foreign']).then(() => {
      this.usersService.business.next('foreign');
    });
  }

  onFuelsSelected() {
    this.router.navigate(['/home/fuels']).then(() => {
      this.usersService.business.next('fuels');
    });
  }

  onIndustrialSelected() {}

  ngOnDestroy(): void {
    this.usersService.inBusinessSelector.next(false);
  }
}
